import React from "react";
import { Grow } from "@mui/material";

const GrowTransition = (props) => {
  return <Grow {...props} />;
};

export default GrowTransition;
